import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react';
import { Toaster as SonnerToaster, toast } from 'sonner';

// Sonner-backed app-wide toast surface, styled to the DS `notification/toast`:
// theme-flipped surface (white/black), semantic icon, 4px left accent (coloured
// per type via the `[data-sonner-toast][data-type]` rules in app.css), dismiss.
export function Toaster(props: React.ComponentProps<typeof SonnerToaster>) {
  return (
    <SonnerToaster
      position="top-right"
      closeButton
      icons={{
        success: <CheckCircle2 className="h-5 w-5 text-notif-icon-success" />,
        error: <XCircle className="h-5 w-5 text-notif-icon-error" />,
        info: <Info className="h-5 w-5 text-notif-icon-informative" />,
        warning: <AlertTriangle className="h-5 w-5 text-notif-icon-warning" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            '!gap-3 !rounded-md !border !border-control-border !border-l-4 !bg-notif-surface !px-3 !py-2 !text-control-foreground !shadow-notif',
          title: '!text-sm !font-normal !text-control-foreground',
          description: '!text-sm !text-notif-body',
          closeButton: '!border-control-border !bg-notif-surface !text-notif-muted',
        },
      }}
      {...props}
    />
  );
}

export { toast };
